import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { PageListComponent } from 'src/app/layout/pages/page-list/page-list.component';
import { IPuntoCampionamento } from '../punti-campionamento.model';
import { PuntiCampionamentoService } from '../punti-campionamento.service';
import { PosizioneGeograficaFormComponent } from '../components/forms/posizione-geografica-form/posizione-geografica-form.component';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FiltersFormComponent } from '../components/forms/filters-form/filters-form.component';
import {
  PUNTICAMPIONAMENTO_VISIBLECOLUMNS,
  PUNTI_CAMPIONAMENTO_COLUMNS,
} from '../punti-campionamento.config';
import { InformazioniFormComponent } from '../components/forms/informazioni-form/informazioni-form.component';
import { UuidFormComponent } from '../components/forms/uuid-form/uuid-form.component';
import { PuntoCampionamentoCardComponent } from '../components/punto-campionamento-card/punto-campionamento-card.component';
import { AreraFormComponent } from '../components/forms/arera-form/arera-form.component';
import { CardComponent } from 'src/app/shared/components/cards/card/card.component';
import { AcquedottoFormComponent } from '../components/forms/acquedotto-form/acquedotto-form.component';
import { ControlliFormComponent } from '../components/forms/controlli-form/controlli-form.component';
import { Ability } from '@casl/ability';
import { AuthService } from 'src/app/core/services/auth.service';
import { DateFormComponent } from '../components/forms/date-form/date-form.component';
import { ICampionamentoExcel } from '../punti-campionamento.model';
import { ExcelService } from '../excel.service';
import { AcquedottoFormInsertComponent } from "../components/forms/acquedotto-form-insert/acquedotto-form-insert.component";

@Component({
  selector: 'app-punticampionamento-lista-page',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PageListComponent,
    UuidFormComponent,
    AreraFormComponent,
    AcquedottoFormComponent,
    InformazioniFormComponent,
    ControlliFormComponent,
    PosizioneGeograficaFormComponent,
    FiltersFormComponent,
    PuntoCampionamentoCardComponent,
    CardComponent,
    DateFormComponent,
    AcquedottoFormInsertComponent
],
  templateUrl: './lista-page.component.html',
  styleUrl: './lista-page.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListaPageComponent {
  columns = PUNTI_CAMPIONAMENTO_COLUMNS;
  visibleColumns = signal(PUNTICAMPIONAMENTO_VISIBLECOLUMNS);
  createPermission: boolean = false;
  insertForm: FormGroup;
  filterForm: FormGroup;
  abilityDefined: boolean = false;

  constructor(
    private readonly fb: FormBuilder,
    public readonly service: PuntiCampionamentoService,
    private ability: Ability,
    private authService: AuthService,
    public excelService: ExcelService
  ) {
    this.insertForm = this.fb.group<IPuntoCampionamento>(
      <IPuntoCampionamento>{}
    );
    this.filterForm = this.fb.group({
      search: this.fb.control('', []),
      filters: this.fb.group({}),
    });
  }
  ngOnInit(): void {
    this.authService.abilityDefined$.subscribe((abilityDefined) => {
      this.abilityDefined = abilityDefined;
      this.createPermission = this.ability.can('create', 'punti-campionamento');
      // Ora puoi fare altro dopo che l'abilità è stata definita
    });
  }

  get filters(): FormGroup {
    return this.filterForm.get('filters') as FormGroup;
  }

  buttonExcelClicked() {
    let filters = this.service.query.filters();

    this.service.getExcelData(filters).subscribe((response: any) => {
      let dataGrezzi = response.content;

      let datiExcel = [];
      for (let i = 0; i < dataGrezzi.length; i++) {
        let itemExcel: ICampionamentoExcel = {
          uuid: '',
          istatRegione: 0,
          istatComune: 0,
          tipoPuntoCampionamento: '',
          idPuntoCampionamento: '',
          idAreraAto: 0,
          idAreraGestore: 0,
          codiceAcquedotto: '',
          wsz: '',
          progressivoLineAcquedottistica: '',
          EPSG4326_lat: 0,
          EPSG4326_lon: 0,
          EPSG4326_z: 0,
          previsioneAbitantiServiti: 0,
          previsionePortata: 0,
          descrizionePunto: '',
          note: '',
          numeroCampionamentoAnnuoInternoPrevisto: 0,
          numeroCampionamentoAnnuoEsterniPrevisto: 0,
          dataInizioValidita: '',
          dataFineValidita: '',
        };
        
        itemExcel.uuid = dataGrezzi[i].uuid;
        itemExcel.istatRegione = dataGrezzi[i].istatRegione;
        itemExcel.istatComune = dataGrezzi[i].istatComune;
        itemExcel.tipoPuntoCampionamento = dataGrezzi[i].tipoPuntoCampionamento;
        itemExcel.idPuntoCampionamento = dataGrezzi[i].idPuntoCampionamento;
        itemExcel.idAreraAto = dataGrezzi[i].idAreraAto;
        itemExcel.idAreraGestore = dataGrezzi[i].idAreraGestore;
        itemExcel.codiceAcquedotto = (dataGrezzi[i] as any).codiceAcquedotto;
        itemExcel.wsz = (dataGrezzi[i] as any).wsz;
        itemExcel.progressivoLineAcquedottistica = dataGrezzi[i].progressivoLineAcquedottistica;
        itemExcel.EPSG4326_lat = dataGrezzi[i].coordinateDTO.lat;
        itemExcel.EPSG4326_lon = dataGrezzi[i].coordinateDTO.lon;
        itemExcel.EPSG4326_z = dataGrezzi[i].coordinateDTO.z;
        itemExcel.previsioneAbitantiServiti = dataGrezzi[i].previsioneAbitantiServiti;
        itemExcel.previsionePortata = dataGrezzi[i].previsionePortata;
        itemExcel.descrizionePunto = dataGrezzi[i].descrizionePunto;
        itemExcel.note = dataGrezzi[i].note;
        itemExcel.numeroCampionamentoAnnuoInternoPrevisto = dataGrezzi[i].numeroCampionamentoAnnuoInternoPrevisto;
        itemExcel.numeroCampionamentoAnnuoEsterniPrevisto = dataGrezzi[i].numeroCampionamentoAnnuoEsterniPrevisto;
        itemExcel.dataInizioValidita = dataGrezzi[i].dataInizioValidita.replaceAll("-", "/");
        itemExcel.dataFineValidita = dataGrezzi[i].dataFineValidita.replaceAll("-", "/");

        datiExcel.push(itemExcel);
      }

      let headers = [];

      for (let key in datiExcel[0]) {
        if (key.includes('_')) {
          key = key.replace('_', ' ');
        }
        headers.push(key);
      }

      this.excelService.generateExcel(datiExcel, headers, 'punti_campionamento');
      
    }); 
  }
  ngOnDestroy(){
    this.service.query.store.setKey('pageable', {})
  }
}